import { Paths } from 'shared/routes/paths';

import { Roadmap } from './roadmap';
import { Summary } from './summary';
import { Tasks } from './tasks';
import { Vision } from './vision';

export const LifeAreaDetailRoutes = [
  {
    path: Paths.LifeAreaDetail,
    element: <Summary />,
  },
  {
    path: Paths.LifeAreaDetailVision,
    element: <Vision />,
  },
  {
    path: Paths.LifeAreaDetailRoadmap,
    element: <Roadmap />,
  },
  {
    path: Paths.LifeAreaDetailTasks,
    element: <Tasks fullSize />,
  },
];
